import logo200Image from '../assets/img/logo/logo_2.png'
import React from 'react'
import { Button, Form, FormGroup, Input, Label, Row, Col, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import Typography from '../components/Typography'
import axios from '../utils/posAxios'
import { MdCameraAlt, MdFace, MdDone, MdClear } from 'react-icons/md'
import Avatar from '../components/Avatar'
import userPlaceholder from '../assets/img/users/profile.jpg'
import StorageService from '../services/StorageService'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { getPayment } from '../utils/dropdownlist'

class PosListOrderForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      list_order: '',
    }
  }

  componentDidMount() {}

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  handleSubmit = event => {
    event.preventDefault()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    this.listorder(user, comp, url)
  }

  listorder(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      product_id_list: this.props.data.checkedRows,
      list_order: this.state.list_order,
      update_by: user.email,
    }

    axios
      .post(url + ':3002/v1/product/store/inventory/listorder/batch', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.props.closeModal(<MdDone />, 'List Order updated successfully.', 'success', false)
      })
      .catch(error => {
        alert(error)
      })
  }

  dropdown(max) {
    var option = []
    for (var i = 0; i <= max; i++) {
      option.push(
        <option key={i} value={i}>
          {i}
        </option>,
      )
    }
    return option
  }

  render() {
    return (
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
        <ModalHeader toggle={this.props.onToggleModal()}>Select List Order</ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Input type="select" name="list_order" value={this.state.list_order} onChange={this.changeHandler} required>
                  {this.dropdown(10)}
                </Input>
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button className="theme-button theme-button-secondary" onClick={this.props.onToggleModal()}>
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>
        </ModalFooter>
      </Form>
    )
  }
}

export const STATE_ADD = 'ADD'
export const STATE_EDIT = 'EDIT'
export default PosListOrderForm
